import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { LookupType } from 'app/enum/Particles';
import { TweenLookupTable, TweenLookupTableParams } from 'particles/lookups/TweenLookupTable';

export class IconLookup2 implements particles.ParticleLookup {
	private _path: Array<particles.ParticleLookupProps> = [];

	constructor() {
		let steps: number = 1000;

		let targetPoints: Array<TweenLookupTableParams> = [
			{ start: { x: -0, y: -0.03 }, end: { x: 0.01, y: 1.05 }, pointCount: Math.round(steps * 0.25) },
			{ start: { x: 0.01, y: 1.05 }, end: { x: 1.15, y: 0.61 }, pointCount: Math.round(steps * 0.25) },
			{ start: { x: 1.15, y: 0.61 }, end: { x: 1.15, y: 0.38 }, pointCount: Math.round(steps * 0.06) },
			{ start: { x: 1.15, y: 0.38 }, end: { x: 0.32, y: 0.71 }, pointCount: Math.round(steps * 0.09) },
			{ start: { x: 0.32, y: 0.71 }, end: { x: 0.32, y: 0.065 }, pointCount: Math.round(steps * 0.09) },
			{ start: { x: 0.32, y: 0.065 }, end: { x: 0, y: -0.03 }, pointCount: Math.round(steps * 0.08) }
		];

		let lookup: TweenLookupTable = new TweenLookupTable();
		let tweenPoints: Array<geometry.Vector2> = lookup.multiTween(targetPoints);

		tweenPoints.forEach((point: geometry.Vector2, index: number) => {
			Math.abs(index - steps / 2) / (steps / 2);
			this._path.push({
				x: point.x,
				y: point.y,
				scale: 0.5,
				alpha: 1,
				rotation: 0
			});
		});
	}

	public get type(): LookupType {
		return LookupType.ICON;
	}

	public get total(): number {
		return this._path.length;
	}

	public get table(): Array<particles.ParticleLookupProps> {
		return this._path;
	}

	public get(index: number): particles.ParticleLookupProps {
		return this._path[index];
	}
}
